import {API_URL } from '../constants/index.js';
import {
    THUMBNAILICON,
    THUMBNAILICON_SUCCESS,
    THUMBNAILICON_ERROR
} from '../constants/thumbnailIconConstants';


//#region GET THUMBNAILICON
export function getThumbnailIcon(data) {
    return {
        type: THUMBNAILICON,
        data
    }
};

export function getThumbnailIconSuccess(data) {
    return {
        type: THUMBNAILICON_SUCCESS,
        data
    }
};

export function getThumbnailIconError(data) {
    return {
        type: THUMBNAILICON_ERROR,
        data
    }
};

export function GetAllTumbnailIcon(idCommunity) {
    return dispatch => {
        dispatch(getThumbnailIcon());
        //dispatch(getThemeSuccess(themeData));
        
        fetch(API_URL+'activities/activitiesIcons',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'CommunityId': idCommunity? idCommunity :  'fca32fc3-6389-4333-bc89-f05564ef8611', 
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getThumbnailIconSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getThumbnailIconError(error));

            })
    }
};

//#endregion